/* DentalCanvas launch kit (canvas page 48): tracking, plan picker, one-plan cart, cart drawer, doctor approve.
   Uses the Shopify AJAX Cart API (/cart.js, /cart/add.js, /cart/update.js, /cart/clear.js) with selling_plan ids.
   Data comes from <script id="dc-lx-data"> (snippets/dc-lx-track.liquid): live plan prices + selling plan ids. */
(function () {
  'use strict';
  if (window.dcLx && window.dcLx.ready) return;
  var W = window, D = document;

  /* ---------- data ---------- */
  var DATA = { plans: {}, install: null, founding: null, currency: 'USD' };
  try { var de = D.getElementById('dc-lx-data'); if (de) DATA = JSON.parse(de.textContent) || DATA; } catch (e) { /* keep defaults */ }
  DATA.plans = DATA.plans || {};
  var KEYS = ['night-shift', 'front-door', 'full-engine'];
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var SUPPORT = 'Please try again, or email <a href="mailto:mustafa@dentcanvas.com">mustafa@dentcanvas.com</a> and Maya will sort it out.';

  function plan(key) { var p = DATA.plans[key]; return p && p.variant && p.monthly ? p : null; }
  function planByHandle(h) { for (var i = 0; i < KEYS.length; i++) { var p = plan(KEYS[i]); if (p && p.handle === h) return p; } return null; }
  function ffLeft() { return DATA.founding && DATA.founding.left > 0 ? DATA.founding.left : 0; }

  /* ---------- storage + tracking ---------- */
  function sget(k) { var v = null; try { v = W.sessionStorage.getItem(k); } catch (e) {} if (v == null) { try { v = W.localStorage.getItem(k); } catch (e) {} } return v; }
  function sset(k, v) { try { W.sessionStorage.setItem(k, v); } catch (e) {} try { W.localStorage.setItem(k, v); } catch (e) {} }
  function clean(v, max, re) { return String(v == null ? '' : v).replace(re, '').trim().slice(0, max); }
  var QS; try { QS = new URLSearchParams(W.location.search); } catch (e) { QS = { get: function () { return null; } }; }
  var RE_CODE = /[^A-Za-z0-9_-]/g, RE_UTM = /[^A-Za-z0-9 _.:|+-]/g, RE_NAME = /[^A-Za-zÀ-ɏ .'-]/g;

  var code = clean(QS.get('c'), 24, RE_CODE);
  if (code) sset('dc_c', code); else code = clean(sget('dc_c'), 24, RE_CODE);
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var utm = {}, fresh = false;
  UTM_KEYS.forEach(function (k) { var v = clean(QS.get(k), 100, RE_UTM); if (v) { utm[k] = v; fresh = true; } });
  /* A new ad code without utms starts a new visit: don't let the last ad's utms ride along. */
  if (fresh || QS.get('c')) sset('dc_utm', JSON.stringify(utm));
  else { try { var o = JSON.parse(sget('dc_utm') || '{}') || {}; UTM_KEYS.forEach(function (k) { if (o[k]) utm[k] = clean(o[k], 100, RE_UTM); }); } catch (e) { utm = {}; } }

  function param(k) {
    var v = QS.get(k);
    if (k === 'plan') { v = clean(v, 20, RE_CODE).toLowerCase(); return KEYS.indexOf(v) > -1 ? v : ''; }
    if (k === 'billing') { v = clean(v, 10, RE_CODE).toLowerCase(); return v === 'yearly' || v === 'monthly' ? v : ''; }
    if (k === 'c') return code;
    return clean(v, 40, RE_NAME);
  }

  var pending = [];
  function publish(name, payload) {
    payload = payload || {};
    if (code && !payload.code) payload.code = code;
    try {
      if (W.Shopify && W.Shopify.analytics && typeof W.Shopify.analytics.publish === 'function') { W.Shopify.analytics.publish(name, payload); return; }
    } catch (e) { return; }
    pending.push([name, payload]);
  }
  W.addEventListener('load', function () {
    var q = pending.splice(0);
    q.forEach(function (p) { try { if (W.Shopify && W.Shopify.analytics && W.Shopify.analytics.publish) W.Shopify.analytics.publish(p[0], p[1]); } catch (e) {} });
  });

  function cartAttributes(extra) {
    var a = {};
    if (code) a['Ad code'] = code;
    ['utm_source', 'utm_campaign', 'utm_content'].forEach(function (k) { if (utm[k]) a[k] = utm[k]; });
    if (extra) Object.keys(extra).forEach(function (k) { if (extra[k]) a[k] = extra[k]; });
    return a;
  }

  /* GHL iframes: pass c + utm (+ any whitelisted page params named in data-lx-pass) so hidden fields capture them */
  function ghl() {
    D.querySelectorAll('iframe[data-lx-ghl]').forEach(function (f) {
      var src = f.getAttribute('src'); if (!src) return;
      var u; try { u = new URL(src, W.location.href); } catch (e) { return; }
      var add = {};
      if (code) add.c = code;
      Object.keys(utm).forEach(function (k) { add[k] = utm[k]; });
      (f.getAttribute('data-lx-pass') || '').split(/\s+/).forEach(function (k) { if (k) { var v = param(k); if (v) add[k] = v; } });
      var changed = false;
      Object.keys(add).forEach(function (k) { if (u.searchParams.get(k) !== add[k]) { u.searchParams.set(k, add[k]); changed = true; } });
      if (changed) f.setAttribute('src', u.toString());
    });
  }

  /* ---------- money + cart API ---------- */
  function money(cents, cur) {
    var n = (Number(cents) || 0) / 100, whole = Math.round(n) === n;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || DATA.currency || 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(n); }
    catch (e) { return '$' + n.toFixed(whole ? 0 : 2); }
  }
  function api(path, body) {
    var opt = { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) { opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return fetch(ROOT + path, opt).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error((j && (j.description || j.message)) || ('Request failed (' + r.status + ')')); e.status = r.status; throw e; }
        return j;
      });
    });
  }
  function kitHandles() {
    var h = [];
    KEYS.forEach(function (k) { var p = plan(k); if (p) h.push(p.handle); });
    if (DATA.install) h.push(DATA.install.handle);
    if (DATA.founding) h.push(DATA.founding.handle);
    return h;
  }
  function clearKitLines(cart) {
    var hs = kitHandles(), up = {}, n = 0;
    (cart.items || []).forEach(function (it) { if (hs.indexOf(it.handle) > -1) { up[it.key] = 0; n++; } });
    return n ? api('cart/update.js', { updates: up }) : Promise.resolve(cart);
  }
  function billingOf(item) {
    var a = item && item.selling_plan_allocation, n = a && a.selling_plan && a.selling_plan.name ? a.selling_plan.name.toLowerCase() : '';
    return /year|annual/.test(n) ? 'yearly' : 'monthly';
  }

  /* Adds one plan (replacing any plan/install lines already in the cart) + the install logic:
     Founding Five spots left -> the $0 Founding Five line; else monthly -> the install product; yearly -> nothing. */
  function addPlan(o) {
    var P = plan(o.plan);
    if (!P) return Promise.reject(new Error('That plan isn’t available to buy online right now.'));
    var billing = o.billing === 'yearly' && P.yearly ? 'yearly' : 'monthly';
    var props = {};
    Object.keys(o.props || {}).forEach(function (k) { if (o.props[k]) props[k] = String(o.props[k]).slice(0, 80); });
    var main = { id: P.variant, quantity: 1, selling_plan: P[billing].plan };
    if (Object.keys(props).length) main.properties = props;
    function lines(useFF) {
      var l = [main];
      if (useFF) l.push({ id: DATA.founding.variant, quantity: 1 });
      else if (billing === 'monthly' && DATA.install) l.push({ id: DATA.install.variant, quantity: 1 });
      return l;
    }
    var useFF = ffLeft() > 0;
    var start = o.clear ? api('cart/clear.js', {}) : api('cart.js').then(clearKitLines);
    return start
      .then(function () {
        return api('cart/add.js', { items: lines(useFF) }).catch(function (err) {
          if (useFF && err.status === 422) { DATA.founding.left = 0; return api('cart/add.js', { items: lines(false) }); }
          throw err;
        });
      })
      .then(function () { return api('cart/update.js', { attributes: cartAttributes(o.attrs) }); })
      .then(function (cart) {
        publish('dc_add_to_cart', { plan: o.plan, billing: billing, value: P[billing].price / 100, currency: cart.currency || DATA.currency });
        setCount(cart.item_count);
        return cart;
      });
  }

  function goCheckout(cart, extra) {
    var p = { value: cart ? cart.total_price / 100 : 0, currency: (cart && cart.currency) || DATA.currency };
    if (extra) Object.keys(extra).forEach(function (k) { p[k] = extra[k]; });
    publish('dc_initiate_checkout', p);
    setTimeout(function () { W.location.href = ROOT + 'checkout'; }, 150);
  }

  function showMsg(el, err) {
    if (!el) return;
    var detail = err && err.status === 422 && err.message ? ' (' + err.message.replace(/[<>]/g, '') + ')' : '';
    el.innerHTML = '';
    var s = D.createElement('span'); s.textContent = 'Sorry — that didn’t go through' + detail + '. ';
    el.appendChild(s);
    var t = D.createElement('span'); t.innerHTML = SUPPORT; el.appendChild(t);
    el.hidden = false;
  }
  function busy(btn, on, label) {
    if (!btn) return;
    if (on) { btn.dataset.lxLabel = btn.textContent; btn.textContent = label || 'Adding…'; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    else { if (btn.dataset.lxLabel) btn.textContent = btn.dataset.lxLabel; btn.disabled = false; btn.removeAttribute('aria-busy'); }
  }
  function setCount(n) {
    D.querySelectorAll('[data-lx-count]').forEach(function (c) { c.textContent = n; c.hidden = !n; });
  }

  /* ---------- drawer ---------- */
  var drawer = D.getElementById('lx-cart'), lastFocus = null, closeTimer = null;
  function el(tag, cls, text) { var e = D.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function focusables() { return drawer ? Array.prototype.filter.call(drawer.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null || x === D.activeElement; }) : []; }
  function onKey(e) {
    if (!drawer || drawer.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (D.activeElement === first || !drawer.contains(D.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (D.activeElement === last || !drawer.contains(D.activeElement))) { e.preventDefault(); first.focus(); }
    }
  }
  function openDrawer(cart) {
    if (!drawer) { W.location.href = ROOT + 'cart'; return; }
    clearTimeout(closeTimer);
    if (drawer.hidden) lastFocus = D.activeElement;
    drawer.hidden = false;
    D.documentElement.style.overflow = 'hidden';
    D.addEventListener('keydown', onKey);
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('open'); }); });
    var closeBtn = drawer.querySelector('.dh [data-lx-close]'); if (closeBtn) closeBtn.focus();
    if (cart) renderCart(cart);
    else { renderLoading(); api('cart.js').then(renderCart).catch(function (e) { renderError(e); }); }
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('open');
    D.documentElement.style.overflow = '';
    D.removeEventListener('keydown', onKey);
    closeTimer = setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function renderLoading() { var b = drawer.querySelector('[data-lx-lines]'); b.innerHTML = ''; b.appendChild(el('p', 'empty', 'Loading your cart…')); drawer.querySelector('[data-lx-foot]').hidden = true; }
  function renderError(err) {
    var b = drawer.querySelector('[data-lx-lines]'); b.innerHTML = '';
    var m = el('p', 'msg'); m.setAttribute('role', 'alert'); b.appendChild(m); showMsg(m, err);
    drawer.querySelector('[data-lx-foot]').hidden = true;
  }
  function removeKeys(keys, btn) {
    var up = {}; keys.forEach(function (k) { up[k] = 0; });
    var body = drawer.querySelector('[data-lx-lines]'); body.classList.add('busy');
    if (btn) btn.textContent = 'Removing…';
    api('cart/update.js', { updates: up }).then(function (cart) { body.classList.remove('busy'); setCount(cart.item_count); renderCart(cart); })
      .catch(function (e) { body.classList.remove('busy'); var m = drawer.querySelector('[data-lx-cart-msg]'); drawer.querySelector('[data-lx-foot]').hidden = false; showMsg(m, e); if (btn) btn.textContent = 'Remove'; });
  }
  function line(title, sub, price, removeKeysList) {
    var row = el('div', 'li'), l = el('div', 'l');
    l.appendChild(el('b', null, title));
    if (sub) l.appendChild(el('span', null, sub));
    if (removeKeysList) {
      var rm = el('button', 'rm', 'Remove'); rm.type = 'button';
      rm.setAttribute('aria-label', 'Remove ' + title);
      rm.addEventListener('click', function () { removeKeys(removeKeysList, rm); });
      l.appendChild(rm);
    }
    row.appendChild(l); row.appendChild(el('span', 'p', price));
    return row;
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    var body = drawer.querySelector('[data-lx-lines]'), foot = drawer.querySelector('[data-lx-foot]');
    body.innerHTML = '';
    var cmsg = drawer.querySelector('[data-lx-cart-msg]'); if (cmsg) cmsg.hidden = true;
    var items = cart.items || [];
    if (!items.length) {
      body.appendChild(el('p', 'empty', 'Your cart is empty.'));
      var a = el('a', 'btn ghost block', 'See plans'); a.href = '/pages/night-shift#pricing';
      a.addEventListener('click', closeDrawer);
      body.appendChild(a);
      foot.hidden = true; return;
    }
    var planItem = null, instItem = null, ffItem = null, others = [];
    items.forEach(function (it) {
      if (!planItem && planByHandle(it.handle)) planItem = it;
      else if (DATA.install && it.handle === DATA.install.handle) instItem = it;
      else if (DATA.founding && it.handle === DATA.founding.handle) ffItem = it;
      else others.push(it);
    });
    var P = planItem ? planByHandle(planItem.handle) : null, billing = planItem ? billingOf(planItem) : 'monthly';
    if (planItem) {
      var free = !!ffItem || !instItem;
      body.appendChild(el('div', 'unl', 'You’ve unlocked: ' + (free ? 'free install · ' : '') + 'welcome box · the Circle ✓'));
      var props = planItem.properties || {}, sub = [];
      if (props['Install afternoon']) sub.push('Install ' + props['Install afternoon']);
      if (props['Open Dental version'] && props['Open Dental version'] !== 'Not sure') sub.push('Open Dental ' + props['Open Dental version']);
      if (props.Workstations) sub.push(props.Workstations + ' workstations');
      var keys = [planItem.key]; if (instItem) keys.push(instItem.key); if (ffItem) keys.push(ffItem.key);
      body.appendChild(line(P.name + ' · ' + (billing === 'yearly' ? 'Yearly' : 'Monthly'), sub.join(' · '), money(planItem.final_line_price, cart.currency) + (billing === 'yearly' ? '/yr' : '/mo'), keys));
      if (ffItem) body.appendChild(line('Install — free · Founding Five', 'Maya installs it in one afternoon', 'Free'));
      else if (instItem) body.appendChild(line('Install afternoon', 'One time · about 45 minutes on your server', money(instItem.final_line_price, cart.currency)));
      else body.appendChild(line('Install — free with yearly', 'Maya installs it in one afternoon', 'Free'));
      body.appendChild(line('Open Dental map poster · gift', null, 'Free'));
    } else {
      if (instItem) others.push(instItem);
      if (ffItem) others.push(ffItem);
    }
    others.forEach(function (it) {
      var o = []; if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) o.push(it.selling_plan_allocation.selling_plan.name);
      if (it.quantity > 1) o.push('Qty ' + it.quantity);
      body.appendChild(line(it.product_title || it.title, o.join(' · '), money(it.final_line_price, cart.currency), [it.key]));
    });
    foot.hidden = false;
    drawer.querySelector('[data-lx-total]').textContent = money(cart.total_price, cart.currency);
    drawer.querySelector('[data-lx-totnote]').textContent = planItem ? (billing === 'yearly' ? 'Then yearly. Install included.' : 'Then monthly. Cancel anytime with one email.') : '';
    var doc = drawer.querySelector('[data-lx-cart-doc]');
    if (doc) { doc.hidden = !P; if (P) doc.href = '/pages/send-to-doctor?plan=' + encodeURIComponent(P.key) + '&billing=' + encodeURIComponent(billing); }
    drawer._cart = cart;
  }
  if (drawer) {
    drawer.querySelectorAll('[data-lx-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    var co = drawer.querySelector('[data-lx-checkout]');
    if (co) co.addEventListener('click', function (e) { e.preventDefault(); goCheckout(drawer._cart); });
  }
  D.querySelectorAll('[data-lx-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); openDrawer(); });
  });

  /* ---------- picker ---------- */
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function installDays() {
    var out = [], d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + 7);
    while (out.length < 4) { var w = d.getDay(); if (w >= 2 && w <= 5) out.push(new Date(d.getTime())); d.setDate(d.getDate() + 1); }
    return out;
  }
  var uidN = 0;
  function buildDays(box) {
    var name = box.getAttribute('data-name') || ('lx-day-' + (++uidN));
    box.innerHTML = '';
    installDays().forEach(function (d, i) {
      var lab = el('label', 'day' + (i === 0 ? ' on' : '')), inp = el('input');
      inp.type = 'radio'; inp.name = name; inp.value = DOW[d.getDay()] + ' ' + MON[d.getMonth()] + ' ' + d.getDate() + ', 12–4 pm';
      inp.setAttribute('data-lx-day', ''); if (i === 0) inp.checked = true;
      lab.appendChild(inp); lab.appendChild(D.createTextNode(DOW[d.getDay()] + ' ' + d.getDate()));
      lab.title = MON[d.getMonth()] + ' ' + d.getDate() + ', 12–4 pm';
      box.appendChild(lab);
    });
  }
  function syncOn(root, sel) { root.querySelectorAll(sel).forEach(function (i) { var l = i.closest('label'); if (l) l.classList.toggle('on', i.checked); }); }
  function checked(root, sel) { var i = root.querySelector(sel + ':checked'); return i ? i.value : ''; }
  function installNote(billing) {
    if (ffLeft() > 0) return 'install free (Founding Five)';
    if (billing === 'yearly') return 'install free';
    return DATA.install ? '+ ' + money(DATA.install.price) + ' install, one time' : '';
  }
  function updatePicker(root) {
    syncOn(root, '[data-lx-plan-opt]'); syncOn(root, '[data-lx-billing-opt]'); syncOn(root, '[data-lx-day]');
    var key = checked(root, '[data-lx-plan-opt]') || root.getAttribute('data-plan') || '';
    var billing = checked(root, '[data-lx-billing-opt]') || 'monthly';
    var P = plan(key);
    /* full mode: yearly only where the plan has a yearly selling plan */
    var yopt = root.querySelector('[data-lx-yearly-opt]');
    if (yopt && key) {
      var noY = !(P && P.yearly), yin = yopt.querySelector('input');
      yopt.classList.toggle('off', noY); yin.disabled = noY;
      if (noY && yin.checked) { yin.checked = false; var m = root.querySelector('[data-lx-billing-opt][value="monthly"]'); if (m) m.checked = true; billing = 'monthly'; syncOn(root, '[data-lx-billing-opt]'); }
      var yo = root.querySelector('[data-lx-yonly]'); if (yo) yo.hidden = !(key === 'full-engine');
    }
    var fe = key === 'full-engine';
    var buy = root.querySelector('[data-lx-buy]'), feb = root.querySelector('[data-lx-fe]'), only = root.querySelector('[data-lx-buyonly]');
    if (buy && key) buy.hidden = fe;
    if (feb && key) feb.hidden = !fe;
    if (only && key) only.hidden = fe;
    if (root.id && key) D.querySelectorAll('[data-lx-for="' + root.id + '"][data-lx-feat]').forEach(function (f) { f.hidden = f.getAttribute('data-lx-feat') !== key; });
    var sum = root.querySelector('[data-lx-sum]');
    if (sum && P) {
      var b = billing === 'yearly' && P.yearly ? 'yearly' : 'monthly';
      sum.textContent = fe ? money(P.monthly.price) + '/mo + ad spend · starts with a free Leak Check'
        : money(P[b].price) + (b === 'yearly' ? '/yr' : '/mo') + (installNote(b) ? ' · ' + installNote(b) : '');
    }
    /* landing cards: swap prices with the billing toggle */
    root.querySelectorAll('[data-lx-price]').forEach(function (p) {
      var k = p.getAttribute('data-lx-price'), PP = plan(k), y = billing === 'yearly' && PP && PP.yearly;
      p.textContent = PP ? money(y ? PP.yearly.price : PP.monthly.price) : p.textContent;
      var u = p.parentNode.querySelector('[data-lx-unit]'); if (u) u.textContent = y ? ' /yr' : (k === 'full-engine' ? ' /mo + ad spend' : ' /mo');
      var mo = p.closest('.pc') && p.closest('.pc').querySelector('[data-lx-monthonly]'); if (mo) mo.hidden = !(billing === 'yearly' && !y);
    });
    var doc = root.querySelector('[data-lx-doclink]');
    if (doc) doc.href = '/pages/send-to-doctor' + (P ? '?plan=' + encodeURIComponent(key) + '&billing=' + encodeURIComponent(billing === 'yearly' && P.yearly ? 'yearly' : 'monthly') : '');
  }
  function gather(root, btn) {
    var key = btn.getAttribute('data-plan') || checked(root, '[data-lx-plan-opt]') || root.getAttribute('data-plan');
    var billing = checked(root, '[data-lx-billing-opt]') || 'monthly';
    var props = { 'Install afternoon': checked(root, '[data-lx-day]') };
    var odv = root.querySelector('[data-lx-odv]'); if (odv && odv.value) props['Open Dental version'] = odv.value;
    var ws = root.querySelector('[data-lx-ws]');
    if (ws && ws.value) { var n = parseInt(ws.value, 10); if (n >= 1 && n <= 99) props.Workstations = String(n); }
    return { plan: key, billing: billing, props: props };
  }
  function initPicker(root) {
    root.querySelectorAll('[data-lx-days]').forEach(buildDays);
    root.addEventListener('change', function (e) { if (e.target.matches('[data-lx-plan-opt],[data-lx-billing-opt],[data-lx-day]')) updatePicker(root); });
    root.querySelectorAll('[data-lx-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var msg = (btn.closest('[data-lx-msgbox]') || root).querySelector('[data-lx-msg]');
        if (msg) msg.hidden = true;
        var o = gather(root, btn), go = btn.getAttribute('data-go') || 'drawer';
        busy(btn, true, go === 'checkout' ? 'Going to checkout…' : 'Adding…');
        addPlan(o).then(function (cart) {
          if (go === 'checkout') { goCheckout(cart, { plan: o.plan, billing: o.billing }); return; }
          busy(btn, false);
          if (drawer) openDrawer(cart); else W.location.href = ROOT + 'cart';
        }).catch(function (err) { busy(btn, false); showMsg(msg, err); });
      });
    });
    updatePicker(root);
  }
  D.querySelectorAll('[data-lx-picker]').forEach(initPicker);

  /* ---------- page bits ---------- */
  D.querySelectorAll('.lx details.menu').forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target.closest('a')) m.removeAttribute('open'); });
    D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.open) { m.removeAttribute('open'); var s = m.querySelector('summary'); if (s) s.focus(); } });
  });

  D.querySelectorAll('[data-lx-if-code]').forEach(function (n) { n.hidden = !code || code.toLowerCase() !== String(n.getAttribute('data-lx-if-code')).toLowerCase(); });
  D.querySelectorAll('[data-lx-if-plan]').forEach(function (n) { n.hidden = param('plan') !== n.getAttribute('data-lx-if-plan'); });
  D.querySelectorAll('[data-lx-param]').forEach(function (n) { var v = param(n.getAttribute('data-lx-param')); if (v) n.textContent = v; });

  /* send-to-doctor + yes: the chosen plan, from ?plan=&billing= */
  function chosen() {
    var key = param('plan'), P = plan(key);
    if (!P) { key = 'night-shift'; P = plan(key); if (!P) { for (var i = 0; i < KEYS.length; i++) { if (plan(KEYS[i]) && KEYS[i] !== 'full-engine') { key = KEYS[i]; P = plan(key); break; } } } }
    var billing = param('billing') === 'yearly' && P && P.yearly ? 'yearly' : 'monthly';
    return { key: key, P: P, billing: billing };
  }
  D.querySelectorAll('[data-lx-chosen]').forEach(function (box) {
    var c = chosen(); if (!c.P || (box.getAttribute('data-lx-need') === 'plan' && !param('plan'))) { box.hidden = true; return; }
    var n = box.querySelector('[data-lx-cn]'), pr = box.querySelector('[data-lx-cp]'), inst = box.querySelector('[data-lx-ci]');
    if (n) n.textContent = c.P.name + ' · ' + (c.billing === 'yearly' ? 'Yearly' : 'Monthly');
    if (pr) pr.textContent = money(c.P[c.billing].price) + (c.billing === 'yearly' ? '/yr' : '/mo') + (c.key === 'full-engine' ? ' + ad spend' : '');
    if (inst) {
      var ip = ffLeft() > 0 || c.billing === 'yearly' || !DATA.install ? 0 : DATA.install.price;
      inst.textContent = ip ? money(ip) : (ffLeft() > 0 ? 'Free · Founding Five' : 'Free');
      var tot = box.querySelector('[data-lx-ct]'); if (tot) tot.textContent = money(c.P[c.billing].price + ip);
    }
    box.hidden = false;
  });

  /* yes page: one tap = clear cart, add the plan (+ install logic), note who approved, go to checkout */
  D.querySelectorAll('[data-lx-approve]').forEach(function (btn) {
    var box = btn.closest('[data-lx-msgbox]') || D, msg = box.querySelector('[data-lx-msg]');
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var c = chosen(); if (msg) msg.hidden = true;
      if (!c.P) { showMsg(msg, new Error('plan unavailable')); return; }
      var dr = param('dr'), from = param('from');
      busy(btn, true, 'Opening secure checkout…');
      addPlan({ plan: c.key, billing: c.billing, clear: true, attrs: { 'Approved by': dr ? 'Dr. ' + dr : 'Doctor', 'Sent by': from } })
        .then(function (cart) { goCheckout(cart, { plan: c.key, billing: c.billing, approved: true }); })
        .catch(function (err) { busy(btn, false); showMsg(msg, err); });
    });
  });

  D.querySelectorAll('[data-lx-event]').forEach(function (n) {
    var name = n.getAttribute('data-lx-event'); if (!/^dc_[a-z_]+$/.test(name)) return;
    var p = { page: W.location.pathname }; var k = n.getAttribute('data-lx-kind'); if (k) p.kind = k;
    var c = chosen(); if (param('plan')) { p.plan = c.key; p.billing = c.billing; }
    publish(name, p);
  });

  ghl();

  W.dcLx = { ready: true, code: function () { return code; }, utm: function () { return utm; }, publish: publish, addPlan: addPlan, openCart: openDrawer, closeCart: closeDrawer, data: DATA };
})();
